import { render, staticRenderFns } from "./LoginOrRegister.vue?vue&type=template&id=3cdbaafc&scoped=true"
import script from "./LoginOrRegister.vue?vue&type=script&lang=js"
export * from "./LoginOrRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbaafc",
  null
  
)

export default component.exports